import barba from '@barba/core'
import { removeElement } from '../utilities'
import { pointerIsFine } from '../utilities/constants'

const activeClass = 'is-active'

export default class {
  constructor(el, options) {
    this.el = el
    this.options = options

    const facebookButton = el.querySelector('.js-dialogFacebook')
    const emailButton = el.querySelector('.js-dialogEmail')
    const shareEl = el.querySelector('.js-share')
    const shareButton = shareEl.querySelector('.js-dialogShare')
    const urlButton = el.querySelector('.js-dialogUrl')

    let focusBeforeOpen = false

    barba.hooks.beforeEnter(function (event) {
      setupDialog(event.next.container)
    })

    function setupDialog(container = document.documentElement) {
      const dialogButtons = container.querySelectorAll('.js-dialogToggle')

      if (!dialogButtons) {
        return
      }

      Array.from(dialogButtons).forEach(function (buttonEl) {
        buttonEl.addEventListener('click', function (event) {
          event.preventDefault()

          if (el.classList.contains(activeClass)) {
            closeDialog()
          } else {
            const url = buttonEl.getAttribute('data-url')
            const text = buttonEl.getAttribute('data-text')

            facebookButton.setAttribute(
              'href',
              `https://www.facebook.com/sharer/sharer.php?u=${url}`
            ) // facebook
            emailButton.setAttribute(
              'href',
              `mailto:?body=${encodeURIComponent(
                text
              )}%0D%0A%0D%0A${encodeURIComponent(url)}`
            ) // email
            shareButton.setAttribute('data-title', text) // share api
            shareButton.setAttribute('data-url', url) // share api
            urlButton.value = url // share url

            el.classList.add(activeClass)
            el.addEventListener('click', closeByOuterClick, false)
            window.addEventListener('keyup', closeByEsc, false)
            focusBeforeOpen = document.activeElement
          }
        })
      })
    }

    function closeByOuterClick(event) {
      const dialogBox = el.querySelector('.js-dialogBox')

      if (
        el.classList.contains(activeClass) &&
        event.target !== dialogBox &&
        dialogBox.contains(event.target) === false
      ) {
        closeDialog()
      }
    }

    function closeByEsc(event) {
      if (event.code === 'Escape' && el.classList.contains(activeClass)) {
        closeDialog()
      }
    }

    function closeDialog() {
      el.classList.remove(activeClass)

      el.removeEventListener('click', closeByOuterClick, false)
      window.removeEventListener('keyup', closeByEsc, false)

      if (focusBeforeOpen) {
        focusBeforeOpen.focus({
          preventScroll: true,
        })
      }

      if (copyEl && copyOriginalText) {
        copyEl.textContent = copyOriginalText
      }
    }

    // Copy API

    const copyEl = el.querySelector('.js-copy')
    const copyOriginalText = copyEl && copyEl.textContent

    if (copyEl) {
      copyEl.addEventListener('click', function () {
        const copyTarget = el.querySelector(copyEl.getAttribute('data-target'))

        if (copyTarget) {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(copyTarget.value)
            copyEl.textContent = 'Copied!'
          } else {
            copyTarget.select()
            if (document.execCommand('copy')) {
              copyEl.textContent = 'Copied!'
            } else {
              copyEl.textContent = 'Failed to copy'
            }
          }
        }
      })
    }

    // Share API
    const isMaybeSmartphone = pointerIsFine === false // This is just guessing

    if (shareButton && navigator.share && isMaybeSmartphone) {
      shareButton.addEventListener('click', function () {
        navigator.share({
          title: shareButton.getAttribute('data-title'),
          url: shareButton.getAttribute('data-url'),
        })
      })
    } else {
      removeElement(shareEl)
    }

    setupDialog()
  }
}
